import NoteLayout from "@/pcomponents/note/layout";
import { useState, useRef, useEffect, useCallback } from 'react';
import getXcolumnJson from "./xcolumn/list";
import ListAggrid from '@/pcomponents/common/crud/list/aggrid/list';
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import strFunc from "@/lib/lyg/string";
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import DiarayViewPopup from "../popup/view";
import DiaryWritePopup from "../popup/write";
import { useSelector, useDispatch } from 'react-redux';

function DiaryListPage() {
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const listAggridRef = useRef<any>();
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    a_category: "",
    s_writer_seq: user.user_seq,
    order_id:'a_order_num, a_ymd DESC, a_seq DESC',
  });
  const [infoArr, setInfoArr] = useState([]); // Set rowData to Array of Objects, one Object per Row
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [category_arr, set_category_arr] = useState([]);
  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "write",//view
    isUpdate: false,
    rowData: {},
    title: "팝업",
    width: "800px",
    height: "85%",
  });

  useEffect(() => {
    get_category_arr_by_ajax();
    list({});
  }, [user]);

  const list = (inOptObj: any) => {
    let change_list_opt = {
      ...listOpt,
      ...inOptObj
    }
    change_list_opt["sc"] = listAggridRef.current.getListSc();
    setListOpt(change_list_opt);

    change_list_opt.s_writer_seq = user.user_seq;
    if (strFunc.is_empty(change_list_opt.s_writer_seq)) {
      return false;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/note/memo/list', change_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          listAggridRef.current.setInfoArr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const get_category_arr_by_ajax = () => {
    let form_json_data: any = {
      group_id: "a_category",
      "s_writer_seq": user.user_seq,
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };

    if (strFunc.is_empty(form_json_data.s_writer_seq)) {
      return false;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/note/memo/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_category_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const deleteByAjax = () => {
    let selected_row = listAggridRef.current.getSelectedRows();
    if (selected_row.length == 0) {
      alert("선택이 없습니다.");
      return false;
    }
    if (!window.confirm("삭제 하시겠습니까?")) {
      return false;
    }
    let form_json_data = {
      "data_arr": selected_row
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/note/memo/delete', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({ "now_page": "1" });
        } else {

        }
      });
  };

const save_order_by_ajax=()=>{
  let rows = listAggridRef.current.getRows();
  for(let i=0; i<rows.length; i++){
    let row = rows[i];
    row.a_order_num = i+1;
  }
  let form_json_data = {
    data_arr: rows
  };
  my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/note/memo/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({ "now_page": "1" });
        } else {

        }
      });
};

  const openViewPopup = () => {
    let selected_row = listAggridRef.current.getSelectedRows();
    if (selected_row.length == 0) {
      alert("선택이 없습니다.");
      return false;
    } else if (selected_row.length != 1) {
      alert("한개만 선택해 주세요.");
      return false;
    }
    let row_data = null;
    if (selected_row.length > 0) {
      row_data = selected_row[0];
    }
    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "view",
      isUpdate: false,
      rowData: row_data,
      title: "팝업",
    });
  };
  const openWritePopup = (inData: any) => {
    let opt_obj = {
      isUpdate: false,
      ...inData
    };
    let row_data = null;
    let title_str = "등록";
    if (opt_obj["isUpdate"]) {
      title_str = "수정";
      let selected_row = listAggridRef.current.getSelectedRows();
      if (selected_row.length == 0) {
        alert("선택이 없습니다.");
        return false;
      } else if (selected_row.length != 1) {
        alert("한개만 선택해 주세요.");
        return false;
      }

      if (selected_row.length > 0) {
        row_data = selected_row[0];
      }
    }

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "write",
      isUpdate: opt_obj["isUpdate"],
      rowData: row_data,
      title: title_str,
    });
  };

  const cellClickedListener = useCallback((params: any) => {
    var key = params.colDef.field;
    if (key == "a_title" || key == "a_category") {
      setTimeout(() => {
        openViewPopup();
      }, 100);
    }
  }, []);

  const cellRenderer = useCallback((params: any) => {
    var key = params.colDef.field;
    var render_str = params.value;

    return render_str;
  }, []);

  const onRowDragEnd=(e:any)=>{
    save_order_by_ajax();
  };

  return (
    <NoteLayout>
      <div className="mt-1">
        <button className={"btn btn_"+(listOpt.s_category== "" ? "blue" : "gray")}
          onClick={() => {
            list({
              s_category: "",
              page_num: 1
            });
          }}
        >전체</button>
        {category_arr.length > 0 &&
          category_arr.map((item: any, index: number) => {
            let is_selected_cat = false;
            if (item.a_category == listOpt.s_category) {
              is_selected_cat = true;
            }
            let btn_class = "btn btn_gray";
            if (is_selected_cat) {
              btn_class = "btn btn_blue";
            }
            btn_class+=" ml-1";
            return (
              <button key={index} className={btn_class}
                onClick={() => {
                  list({
                    s_category: item.a_category,
                    page_num: 1
                  });
                }}
              >{item.a_category}</button>
            );
          })
        }
      </div>
      <div className="mt-1">
        <button className="btn btn_gray" onClick={openWritePopup}>등록</button>
        <button className="btn btn_gray ml-1" onClick={openViewPopup}>보기</button>
        <button className="btn btn_gray ml-1" onClick={() => { openWritePopup({ "isUpdate": true }); }}>수정</button>
        <button className="btn btn_gray ml-1" onClick={deleteByAjax}>삭제</button>
      </div>
      <ListAggrid
        ref={listAggridRef}
        infoArr={infoArr}
        xColumnArr={{ ...xColumnArr }}
        list={list}
        gridOpt={{
          fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
          is_idx_num: false,
          is_add_checkbox: false,
          floatingFilter: true,
          is_add_rowDrag: true,
          onGridReady: () => {
            //list({});
          },
          onCellClicked: cellClickedListener,
          cellRenderer: cellRenderer,
          onRowDragEnd:onRowDragEnd,
        }}
      ></ListAggrid>
      <Paging now_page={listOpt.now_page}
        num_per_page={listOpt.num_per_page}
        total_rec={countInfo.tot}
        onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
        onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>

      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} y={0}
          title_bar_style={{ display: "none" }}>
          {popupData.sort === "view" &&
            <DiarayViewPopup
              rowData={popupData.rowData} callback={() => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></DiarayViewPopup>
          }
          {popupData.sort === "write" &&
            <DiaryWritePopup
              isUpdate={popupData.isUpdate}
              rowData={popupData.rowData}
              callback={() => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></DiaryWritePopup>
          }
        </LayerPopup>
      }
    </NoteLayout>
  );
};
export default DiaryListPage;